module.exports = __webpack_public_path__ + "static/media/equipment_03.786381b6.jpg";